import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import { useEffect, useState, useLayoutEffect, useContext } from "react";
import { useCookies } from "react-cookie";

//Componenti
import Breadcrumb from "./Breadcrumb";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";

//Pagine Operatore
import ListRanges from "../Page/Operator/ListRanges";
import Home from "../Page/Operator/Home";
import ListISEEUploaded from "../Page/Operator/ListISEEUploaded";
import ListISEEValidated from "../Page/Operator/ListISEEValidated";
import ListAnnouncements from "../Page/Operator/ListAnnouncements";
import ListFlows from "../Page/Operator/ListFlows";
import ListPayments from "../Page/Operator/ListPayments";
import ListPaymemtsStatus from "../Page/Operator/ListPaymentsStatus";
import CheckISEE from "../Page/Operator/CheckISEE";
import ViewISEE from "../Page/Operator/ViewISEE";
import EditRange from "../Page/Operator/EditRange";
import UploadISEEOperator from "../Page/Operator/UploadISEE";
import NewRange from "../Page/Operator/NewRange";
import ListUsers from "../Page/Operator/ListUsers";
import ListServices from "../Page/Operator/ListServices";
import NewService from "../Page/Operator/NewService";
import NewUser from "../Page/Operator/NewUser";
import EditUser from "../Page/Operator/EditUser";
import EditService from "../Page/Operator/EditService";
import ListTikets from "../Page/Operator/ListTickets";
import ListISEEValidationLogs from "../Page/Operator/ListISEEValidationLogs";

//Pagine Delegato
import HomeDelegate from "../Page/Delegate/HomeDelegate";

//Pagine utente
import HomeUser from "../Page/User/HomeUser";
import UploadISEE from "../Page/User/UploadISEE";
import ListAnnouncementsServices from "../Page/User/ListAnnouncementsServices";
import UserProfile from "../Page/User/UserProfile";
import NewAnnouncement from "../Page/Operator/NewAnnouncement";
import EditAnnouncement from "../Page/Operator/EditAnnouncement";
import AnnouncementDetail from "../Page/Operator/AnnouncementDetail";
import ViewAnnouncements from "../Page/User/ViewAnnouncements";
import Help from "../Page/User/Help";
import ListPaymemts from "../Page/Operator/ListPayments";
import jwt_decode from "jwt-decode";

//Slogged
import HomeNoLogin from "../Page/NoLogin/Home";
import Subscription from "../Page/User/Subscription";
import Configuration from "../Page/Operator/Configuration";
import ViewAnnouncementsNoLogin from "../Page/NoLogin/ViewAnnouncements";
import EditTicket from "../Page/Operator/EditTicket";
import BatchUpdates from "../Page/Operator/BatchUpdates";
import BatchUpdateLogs from "../Page/Operator/BatchUpdateLogs";
import DettaglioIscrizione from "../Page/Operator/DettaglioIscrizione";

//Common
import PrivacyPolicy from "../Page/Common/PrivacyPolicy";

//Context
import { TokenContext } from "../Components/TokenContext";

function Body(props) {
  const [cookies] = useCookies();
  const apiToken = useContext(TokenContext);

  const [isOperator, setIsOperator] = useState(false);
  const [isDelegate, setIsDelegate] = useState(false);
  const [isCitizen, setIsCitizen] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [codiceFiscale, setCodiceFiscale] = useState("");
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (cookies.user_profile) {
      if (cookies.user_profile.WorkingEntityId) {
        setIsOperator(true);
      } else {
        setCodiceFiscale(cookies.user_profile.FiscalCode);
      }
    }

    if (codiceFiscale) {
      setCodiceFiscale(cookies.user_profile.FiscalCode);
    }

    // Se apiToken è presente, decodifica e imposta i ruoli
    if (apiToken) {
      try {
        const decodedApiToken = jwt_decode(apiToken);

        if (decodedApiToken.role?.includes("CITIZEN")) {
          setIsCitizen(true);
          console.log("CITIZEN");
        }
        if (decodedApiToken.role?.includes("OPERATOR")) {
          setIsOperator(true);
          console.log("OPERATOR");
        }
        if (decodedApiToken.role?.includes("DELEGATE")) {
          setIsDelegate(true);
          setIsOperator(false);
          console.log("Delegate");
        }
      } catch (error) {
        console.error("apiToken non valido:", error);
      }
    }
  }, [apiToken]);

  function PageNotFound() {
    const history = useHistory();
    return (
      <>
        <div className="row">
          <h1>Autorizzazione negata</h1>

          <div className="clearfix col-lg-8 py-lg-2">
            <p>Non sei autorizzato a visualizzare questa pagina.</p>
          </div>
          <div className="col-lg-4 d-flex justify-content-end">
            <div>
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => history.goBack()}
              >
                {" "}
                Indietro{" "}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <main role="main" className="main-body">
      {apiToken ? (
        <>
          {isDelegate && (
            <div className="container shadow-sm p-3 mb-5 bg-white rounded">
              <div>
                <Switch>
                  <Route exact path="/lista_utenti">
                    <Breadcrumb></Breadcrumb>
                    <ListUsers subfolder={props.subfolder}></ListUsers>
                  </Route>
                  <Route exact path="/lista_utenti/dati_utente">
                    <Breadcrumb></Breadcrumb>
                    <EditUser subfolder={props.subfolder}></EditUser>
                  </Route>

                  <Route
                    exact
                    path={[
                      "/lista_bandi/bando/lista_pagamenti",
                      "/lista_bandi/dettaglio_sessione/lista_pagamenti",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <ListPayments subfolder={props.subfolder}></ListPayments>
                  </Route>

                  <Route path="/">
                    <HomeDelegate
                      userDataStatus={props.userDataStatus}
                      subfolder={props.subfolder}
                    ></HomeDelegate>
                  </Route>

                  <Route path="*">
                    <PageNotFound />
                  </Route>
                </Switch>
              </div>
            </div>
          )}

          {/*     Pagine Utente  */}
          {isCitizen && (
            <div className="container mb-5 mt-3 shadow-sm p-3 mb-5 bg-white rounded">
              <Switch>
                <Route exact path="/iscrizioni">
                  <Breadcrumb></Breadcrumb>
                  <Subscription subfolder={props.subfolder}></Subscription>
                </Route>
                <Route exact path="/caricamento_ISEE">
                  <Breadcrumb></Breadcrumb>
                  <UploadISEE subfolder={props.subfolder}></UploadISEE>
                </Route>
                <Route exact path="/sessione_servizi">
                  <Breadcrumb></Breadcrumb>
                  <ListAnnouncementsServices
                    subfolder={props.subfolder}
                  ></ListAnnouncementsServices>
                </Route>
                <Route
                  exact
                  path={[
                    "/sessione_servizi/visualizza_servizio",
                    "/iscrizioni/visualizza_servizio",
                  ]}
                >
                  <Breadcrumb></Breadcrumb>
                  <ViewAnnouncements
                    subfolder={props.subfolder}
                  ></ViewAnnouncements>
                </Route>
                <Route exact path="/profilo">
                  <Breadcrumb></Breadcrumb>
                  <UserProfile subfolder={props.subfolder}></UserProfile>
                </Route>
                <Route path="/privacy_policy">
                  <Breadcrumb></Breadcrumb>
                  <PrivacyPolicy subfolder={props.subfolder}></PrivacyPolicy>
                </Route>
                <Route path="/supporto">
                  <Breadcrumb></Breadcrumb>
                  <Help subfolder={props.subfolder}></Help>
                </Route>
                <Route path="/">
                  <HomeUser
                    userDataStatus={props.userDataStatus}
                    subfolder={props.subfolder}
                  ></HomeUser>
                </Route>
              </Switch>
            </div>
          )}
          {/* Pagine Operatore  */}

          {isOperator && (
            <div className="container shadow-sm p-3 mb-5 bg-white rounded">
              <div>
                <Switch>
                  <Route exact path="/lista_utenti">
                    <Breadcrumb></Breadcrumb>
                    <ListUsers subfolder={props.subfolder}></ListUsers>
                  </Route>
                  <Route exact path="/lista_utenti/nuovo_utente">
                    <Breadcrumb></Breadcrumb>
                    <NewUser subfolder={props.subfolder}></NewUser>
                  </Route>
                  <Route exact path="/lista_utenti/dati_utente">
                    <Breadcrumb></Breadcrumb>
                    <EditUser subfolder={props.subfolder}></EditUser>
                  </Route>
                  <Route
                    exact
                    path="/lista_utenti/dati_utente/iscrizione/:iscrizioneId"
                  >
                    <Breadcrumb />
                    <DettaglioIscrizione subfolder={props.subfolder} />
                  </Route>
                  <Route exact path="/lista_utenti/dati_utente/ticket">
                    <Breadcrumb></Breadcrumb>
                    <ListTikets subfolder={props.subfolder}></ListTikets>
                  </Route>
                  <Route
                    exact
                    path="/lista_utenti/dati_utente/ticket/dettaglio"
                  >
                    <Breadcrumb></Breadcrumb>
                    <EditTicket subfolder={props.subfolder}></EditTicket>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/caricamento_ISEE_operatore",
                      "/lista_utenti/dati_utente/caricamento_ISEE_operatore",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <UploadISEEOperator
                      subfolder={props.subfolder}
                    ></UploadISEEOperator>
                  </Route>

                  <Route exact path="/pagamenti">
                    <Breadcrumb></Breadcrumb>
                    <ListPaymemtsStatus
                      subfolder={props.subfolder}
                    ></ListPaymemtsStatus>
                  </Route>

                  <Route exact path="/lista_bandi">
                    <Breadcrumb></Breadcrumb>
                    <ListAnnouncements
                      subfolder={props.subfolder}
                    ></ListAnnouncements>
                  </Route>
                  <Route exact path="/fasce">
                    <Breadcrumb></Breadcrumb>
                    <ListRanges subfolder={props.subfolder}></ListRanges>
                  </Route>
                  <Route exact path="/lista_isee">
                    <Breadcrumb></Breadcrumb>
                    <ListISEEUploaded
                      subfolder={props.subfolder}
                    ></ListISEEUploaded>
                  </Route>

                  <Route exact path="/lista_isee/logs">
                    <Breadcrumb />
                    <ListISEEValidationLogs />
                  </Route>
                  <Route exact path="/lista_ticket">
                    <Breadcrumb></Breadcrumb>
                    <ListTikets subfolder={props.subfolder}></ListTikets>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/lista_utenti/dati_utente/verifica_isee",
                      "/lista_isee/verifica_isee",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <CheckISEE subfolder={props.subfolder}></CheckISEE>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/visualizza_isee",
                      "/lista_utenti/dati_utente/visualizza_isee",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <ViewISEE subfolder={props.subfolder}></ViewISEE>
                  </Route>
                  <Route exact path="/fasce/modifica_fascia">
                    <Breadcrumb></Breadcrumb>
                    <EditRange subfolder={props.subfolder}></EditRange>
                  </Route>
                  <Route exact path="/fasce/nuova_fascia">
                    <Breadcrumb></Breadcrumb>
                    <NewRange subfolder={props.subfolder}></NewRange>
                  </Route>
                  <Route exact path="/servizi">
                    <Breadcrumb></Breadcrumb>
                    <ListServices subfolder={props.subfolder}></ListServices>
                  </Route>
                  <Route exact path="/servizi/nuovo_servizio">
                    <Breadcrumb></Breadcrumb>
                    <NewService subfolder={props.subfolder}></NewService>
                  </Route>
                  <Route exact path="/servizi/visualizza_servizio">
                    <Breadcrumb></Breadcrumb>
                    <EditService subfolder={props.subfolder}></EditService>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/lista_bandi/nuova_sessione",
                      "/servizi/visualizza_servizio/nuova_sessione",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <NewAnnouncement
                      subfolder={props.subfolder}
                    ></NewAnnouncement>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/lista_bandi/bando/modifica_sessione",
                      "/lista_bandi/dettaglio_sessione/modifica_sessione",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <EditAnnouncement
                      subfolder={props.subfolder}
                    ></EditAnnouncement>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/lista_bandi/bando",
                      "/lista_bandi/dettaglio_sessione",
                      "/servizi/visualizza_servizio/bando",
                      "/servizi/visualizza_servizio/dettaglio_sessione",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <AnnouncementDetail
                      subfolder={props.subfolder}
                    ></AnnouncementDetail>
                  </Route>
                  <Route
                    exact
                    path={[
                      "/lista_bandi/bando/lista_pagamenti",
                      "/lista_bandi/dettaglio_sessione/lista_pagamenti",
                    ]}
                  >
                    <Breadcrumb></Breadcrumb>
                    <ListPayments subfolder={props.subfolder}></ListPayments>
                  </Route>
                  <Route exact path={["/flussi_mypay"]}>
                    <Breadcrumb></Breadcrumb>
                    <ListFlows subfolder={props.subfolder}></ListFlows>
                  </Route>
                  <Route exact path={"/configurazione"}>
                    <Breadcrumb></Breadcrumb>
                    <Configuration subfolder={props.subfolder}></Configuration>
                  </Route>
                  <Route exact path="/gestione_aggiornamenti">
                    <Breadcrumb></Breadcrumb>
                    <BatchUpdates subfolder={props.subfolder}></BatchUpdates>
                  </Route>

                  <Route path="/gestione_aggiornamenti/:jobId/logs">
                    <Breadcrumb />
                    <BatchUpdateLogs />
                  </Route>

                  <Route path="/privacy_policy">
                    <Breadcrumb></Breadcrumb>
                    <PrivacyPolicy subfolder={props.subfolder}></PrivacyPolicy>
                  </Route>
                  <Route exact path="/">
                    <Home subfolder={props.subfolder}></Home>
                  </Route>
                  <Route path="*" element={<PageNotFound />} />
                </Switch>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {
            /* Pagine Non Loggato  */
            // console.log("nologin")
          }
          <div className="container mb-5 mt-3">
            <Switch>
              <Route exact path={["/sessione_servizi/visualizza_servizio"]}>
                <Breadcrumb></Breadcrumb>
                <ViewAnnouncementsNoLogin
                  subfolder={props.subfolder}
                ></ViewAnnouncementsNoLogin>
              </Route>
              <Route path="/privacy_policy">
                <Breadcrumb></Breadcrumb>
                <PrivacyPolicy subfolder={props.subfolder}></PrivacyPolicy>
              </Route>
              <Route exact path="/">
                <HomeNoLogin subfolder={props.subfolder}></HomeNoLogin>
              </Route>

              <Route path="*" element={<PageNotFound />} />
            </Switch>
          </div>
        </>
      )}

      {isOpen && (
        <Modal isOpen={isOpen} labelledBy="esempio1">
          <ModalHeader id="esempio1">SESSIONE SCADUTA</ModalHeader>
          <ModalBody>Esegui nuovamente il login</ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() =>
                (window.location.href = props.subfolder + "/login")
              }
            >
              Login
            </Button>
            <Button
              color="primary"
              onClick={() => (window.location.href = props.subfolder + "/")}
            >
              Home
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </main>
  );
}

export default Body;
